import { Button, Group, Loader, Paper, Stack, Text } from '@mantine/core';
import { IconPlayerPlay, IconVolume } from '@tabler/icons-react';
import { useConnectionState, useRoomContext, useStartAudio, useStartVideo } from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import { useTranslation } from 'react-i18next';

export function ConnectionStatus() {
    const { t } = useTranslation('conference');
    const room = useRoomContext();
    const connectionState = useConnectionState(room);
    const { canPlayAudio, mergedProps: startAudioProps } = useStartAudio({ room, props: {} });
    const { canPlayVideo, mergedProps: startVideoProps } = useStartVideo({ room, props: {} });

    let connectionLabel: string | undefined;
    if (connectionState === ConnectionState.Connecting) connectionLabel = t('connection.connecting');
    if (connectionState === ConnectionState.Reconnecting || connectionState === ConnectionState.SignalReconnecting) {
        connectionLabel = t('connection.reconnecting');
    }

    if (!connectionLabel && canPlayAudio && canPlayVideo) return null;

    return (
        <Stack
            align="center"
            gap="var(--spacing-2)"
            left="50%"
            pos="absolute"
            style={{ transform: 'translateX(-50%)', zIndex: 'var(--z-index-dropdown)' }}
            top="var(--spacing-16)"
        >
            {connectionLabel && (
                <Paper aria-live="polite" px="var(--spacing-4)" py="var(--spacing-3)" role="status" shadow="sm">
                    <Group gap="var(--spacing-2)" wrap="nowrap">
                        <Loader size="xs" />
                        <Text fw={500} size="sm">
                            {connectionLabel}
                        </Text>
                    </Group>
                </Paper>
            )}
            {!canPlayAudio && (
                <Button leftSection={<IconVolume size={20} />} onClick={startAudioProps.onClick}>
                    {t('media.startAudio')}
                </Button>
            )}
            {!canPlayVideo && (
                <Button leftSection={<IconPlayerPlay size={20} />} onClick={startVideoProps.onClick}>
                    {t('media.startVideo')}
                </Button>
            )}
        </Stack>
    );
}
